import script from "./ManagementLayout.vue?vue&type=script&setup=true&lang=js"
export * from "./ManagementLayout.vue?vue&type=script&setup=true&lang=js"

import "./ManagementLayout.vue?vue&type=style&index=0&id=590d71fe&lang=scss&scoped=true"
import "./ManagementLayout.vue?vue&type=style&index=1&id=590d71fe&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-590d71fe"]])

export default __exports__